'use strict';

/* globals define, ajaxify, $, socket, app, utils, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/lesson/lesson-editor', [
	config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js',
	'translator',
	'benchpress',
	'lessonCreator',
	'coverPhoto',
	'pictureCropper',
	'slugify',
	'bootbox',
], function (vue, translator, Benchpress, lessonCreator, coverPhoto, pictureCropper, slugify, bootbox) {
	var	LessonEditor = {};

	var uploadingData = {
		onStart: function () {},
		onEnd: function () {},
		onProgress: function () {},
	};

	LessonEditor.init = function () {
		lessonCreator.init(ajaxify.data.lesson, ajaxify.data.translations);

		addActions();
	};

	function addActions() {
		var actions = {
			'add-video': uploadVideo,
			'add-sound': uploadSound,
			'add-cover': addCover,
			'remove-video': removeVideo,
			'remove-sound': removeSound,
			'remove-cover': removeCover,
			update: updateLesson,
			publish: publishLesson,
			delete: deleteLesson,
		};

		for (var key in actions) {
			if (actions.hasOwnProperty(key)) {
				$('[data-action="' + key + '"]').click(actions[key]);
			}
		}

		addUploadAction();
	}

	function updateLesson() {
		save('plugins.lessons.updateLesson');
	}

	function publishLesson() {
		save('plugins.lessons.publishLesson');
	}

	function save(saveUrl) {
		applyFormValues();

		var data = $.extend({}, ajaxify.data.lesson, { questions: getParsedQuestions() });

		socket.emit(saveUrl, data, function (err) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'lesson_edited',
				message: '[[lessons:lesson-edited]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('groups/' + ajaxify.data.group.slug + '/lesson/' + ajaxify.data.lesson.lessonId + '/' + slugify(ajaxify.data.lesson.name));
		});
	}

	function getParsedQuestions() {
		var questions = [];

		for (var questionIndex = 0; questionIndex < ajaxify.data.lesson.questions.length; questionIndex++) {
			var question = ajaxify.data.lesson.questions[questionIndex];

			var answers = [];

			for (var answerIndex = 0; answerIndex < question.answers.length; answerIndex++) {
				var answer = question.answers[answerIndex];

				answers.push({
					content: answer.content,
					name: answer.name,
					type: answer.type,
					isValid: answer.isValid,
				});
			}

			questions.push({
				question: question.question,
				media: question.media,
				answers: answers,
				keyframes: question.keyframes,
			});
		}

		return questions;
	}

	function applyFormValues() {
		ajaxify.data.lesson.description = $('#description').val();
		ajaxify.data.lesson.name = $('#name').val();
		ajaxify.data.lesson.isVisible = $('#isVisible').is(':checked');
		ajaxify.data.lesson.content = $('#text-content').val();
		ajaxify.data.lesson.goodbyeContent = $('#text-goodbye-content').val();
		ajaxify.data.lesson.videoDisabledControls = $('#video-disabled-controls').prop('checked');
	}

	function deleteLesson() {
		bootbox.confirm('Do you want to delete lesson?', function (confirm) {
			if (!confirm) {
				return;
			}

			var data = $.extend({}, ajaxify.data.lesson, { questions: [] });

			socket.emit('plugins.lessons.removeLesson', data, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					alert_id: 'lesson_removed',
					message: '[[lessons:lesson-removed]]',
					type: 'success',
					timeout: 2000,
				});

				ajaxify.go('groups/' + ajaxify.data.group.slug + '/lessons');
			});
		});
	}

	function uploadVideo() {
		var me = this;

		var btnInitialContent = $(me).html();

		uploadingData.onStart = function () {
			$(me).attr('disabled', 'disabled');
		};

		uploadingData.onProgress = function (progress) {
			$(me).html('<i class="fa fa-spinner fa-spin" aria-hidden="true"></i> ' + progress + '%');
		};

		uploadingData.onEnd = function (uploads) {
			$(me).html(btnInitialContent);
			$(me).removeAttr('disabled');
			$(me).hide();

			saveFilePrivileges(uploads.name);

			ajaxify.data.lesson.video = uploads.url;

			$('#contentVideo span').html('<div class="custom-video" data-video-url="' + uploads.url + '"></div>');
			$('#contentVideo').show();

			$('.custom-video')
				.delay(500)
				.customVideo();
		};

		$('#contentFileForm #files').click();
	}

	function uploadSound() {
		var me = this;

		var btnInitialContent = $(me).html();

		uploadingData.onStart = function () {
			$(me).attr('disabled', 'disabled');
		};

		uploadingData.onProgress = function (progress) {
			$(me).html('<i class="fa fa-spinner fa-spin" aria-hidden="true"></i> ' + progress + '%');
		};

		uploadingData.onEnd = function (uploads) {
			$(me).html(btnInitialContent);
			$(me).removeAttr('disabled');
			$(me).hide();

			saveFilePrivileges(uploads.url);

			ajaxify.data.lesson.sound = uploads.url;

			$('#contentSound span').html('<audio controls><source src="' + uploads.url + '"></audio>');
			$('#contentSound').show();
		};

		$('#contentFileForm #files').click();
	}

	function addCover() {
		pictureCropper.show({
			title: '[[ideas-board:select-image]]',
			socketMethod: 'plugins.lessons.uploadPicture',
			aspectRatio: NaN,
			allowSkippingCrop: true,
			restrictImageDimension: false,
		}, function (imageUrl) {
			saveFilePrivileges(imageUrl);

			ajaxify.data.lesson.cover = imageUrl;

			$('#contentCover img').attr('src', imageUrl);
			$('#contentCover').show();
			$('[data-action="add-cover"]').hide();
		});
	}

	function removeVideo() {
		$('#contentVideo span').html('');
		$('#contentVideo').hide();
		$('[data-action="add-video"]').show();

		ajaxify.data.lesson.video = null;
	}

	function removeSound() {
		$('#contentSound span').html('');
		$('#contentSound').hide();
		$('[data-action="add-sound"]').show();

		ajaxify.data.lesson.sound = null;
	}

	function removeCover() {
		$('#contentCover img').attr('src', '');
		$('#contentCover').hide();
		$('[data-action="add-cover"]').show();

		ajaxify.data.lesson.cover = null;
	}

	function saveFilePrivileges(fileName) {
		socket.emit('plugins.filePermissionSockets.saveFileFromGroupPrivileges', { fileName: fileName, groupName: ajaxify.data.group.name }, function (err) {
			if (err) {
				return app.alertError(err.message);
			}
		});
	}

	function addUploadAction() {
		$('#contentFileForm #files').on('change', function (e) {
			var files = (e.target || {}).files || ($(this).val() ? [{ name: $(this).val(), type: utils.fileMimeType($(this).val()) }] : null);

			if (files) {
				uploadFile({
					files: files,
					route: '/api/post/upload',
					filename: $(this).val().replace(/^.*[\\/]/, ''),
				});
			}
		});
	}

	function uploadFile(params) {
		var filesForm = $('#contentFileForm');

		filesForm.attr('action', config.relative_path + params.route);

		filesForm.off('submit').submit(function () {
			uploadingData.onStart();

			$(this).ajaxSubmit({
				headers: {
					'x-csrf-token': config.csrf_token,
				},
				resetForm: true,
				clearForm: true,
				formData: params.formData,
				data: { },

				error: function (xhr) {
					app.alertError(xhr.responseJSON.error);
				},

				uploadProgress: function (event, position, total, percent) {
					uploadingData.onProgress(percent);
				},

				success: function (uploads) {
					uploadingData.onEnd(uploads.response.images[0] || {});
				},

				complete: function () {

				},
			});

			return false;
		});

		filesForm.submit();
	}

	return LessonEditor;
});
